import { CheckFilled } from '../../assets/icons';
import { Colors } from '../../constants';
import { motion } from 'framer-motion';

type FeatureListItemProps = {
  title: string;
  description: string;
  index: number;
};

const variants = {
  visible: (custom: number) => ({
    opacity: 1,
    transition: { delay: custom * 0.2 },
  }),
};

export function FeatureListItem(props: FeatureListItemProps) {
  return (
    <motion.div custom={props.index} className="flex items-start justify-start" animate="visible" variants={variants}>
      <div className="pt-1 pr-4">
        <CheckFilled width={24} fill={Colors.olive} />
      </div>
      <div className="flex flex-col mb-5">
        <span className="font-extrabold">{props.title}</span>
        <span>{props.description}</span>
      </div>
    </motion.div>
  );
}
